export function isExist(value: any): boolean {
  return value !== undefined && value !== null;
}
